



















































import { defineComponent, toRefs, PropType, computed } from '@vue/composition-api';
import { AdgroupConfig, AdgroupFormData, CampaignFormData, CreateMode, ExternalType } from '@tt4b/ttam-enums';
import PromotionType from './index';
import { useAdgroupMode } from '@tt4b/ttam-hooks';
import { trackEvent } from './../../../utils/index';

const name = 'ttam-promotion-type-compose';
export default defineComponent({
  name,
  // components: {
  //   TtamPromotionType: PromotionType.TtamPromotionType,
  // },
  props: {
    campaignData: {
      type: Object as PropType<CampaignFormData>,
      default: () => ({}),
    },
    adgroupData: {
      type: Object as PropType<AdgroupFormData>,
      default: () => ({}),
    },
    adgroupConfig: {
      type: Object as PropType<AdgroupConfig>,
      default: () => ({}),
    },
    createMode: {
      type: String as PropType<CreateMode>,
      default: CreateMode.CREATE,
    },
  },
  setup(props, { emit }) {
    const { adgroupData, campaignData, createMode } = toRefs(props);
    const { list } = PromotionType.usePropsList({ campaignData, adgroupData });
    const { isEdit } = useAdgroupMode({ createMode });
    const disabled = computed(() => isEdit.value || props.adgroupConfig.disableAll);

    const getSelected = val => list.value.find(item => item.value.includes(val));
    // const externalType = computed({
    //   get: () => adgroupData.value.externalType,
    //   set: (val: ExternalType) => {
    //     emit('input', val);
    //   },
    // });
    const externalType = computed(() => {
      const target = getSelected(adgroupData.value.externalType);
      return target ? target.value?.[0] : adgroupData.value.externalType;
    });

    const handleClick = (val: ExternalType) => {
      const target = getSelected(val);
      if (!disabled.value && !target.disabled) {
        if (target.clickEventKey) {
          trackEvent(target.clickEventKey);
        }
        emit('input', target.value?.[0]);
        emit('change-item', target);
      }
    };
    // const onChangeType = (val: TypeItem) => {
    //   emit('change-item', val);
    // };

    const { visible } = PromotionType.usePropsVisible({ campaignData });
    const { externalTypeValidator } = PromotionType.useRules();

    return {
      name,
      isEdit,
      disabled,
      list,
      visible,
      externalType,
      externalTypeValidator,
      handleClick,
      // onChangeType,
    };
  },
});
